<div class="login-page">
  <header class="login-header">
    <img
      class="login-flag"
      src="assets/images/ACL_Flag_Logo.png"
      alt="American Explorer"
    />
    <h1 class="login-brand">AMERICAN EXPLORER</h1>
    <div class="login-divider" aria-hidden="true"></div>
    <p class="login-tagline">
      Your adventure awaits. Log in to explore your personalized journey.
    </p>
  </header>

  <section class="login-body">
    <app-login-prompt></app-login-prompt>
    <div class="login-message">Ready for your next adventure?</div>
    <div class="contact-info">1-888-458-5979</div>
  </section>

  <footer class="login-footer">
    <div class="footer-copyright">© Copyright {{currentYear}} American Cruise Lines. All rights reserved.</div>
  </footer>

</div>
